import React, { FC } from 'react'

type IconHashType = 'minus' | 'plus' | 'trash' | 'arrow-left'

interface IIconProps {
  hash: IconHashType
  size: number
  color?: `#${string}`
}

const Icon: FC<IIconProps> = (props) => {
  return (
    <svg width={props.size} height={props.size} color={props.color} stroke={props.color}>
      <use href={`/icons-v2.svg#${props.hash}`} />
    </svg>
  )
}

export default Icon
